import { TRACKING_EVENT_NAMES } from 'hooks/analytics_events/constants'

const NOTETAKER_ET_TOGGLE_CTA_KEY = 'notetaker_et_toggle'
const NOTETAKER_ET_TOGGLE_CTA_TEXT = 'add_notetaker_toggle'
const NOTETAKER_ET_TOGGLE_SETTING_NAME = 'notetaker_et_toggle'

const getFlow = (flow) => (flow === 'edit' ? 'edit' : 'create')

export const buildNotetakerEtToggleSeenTrackingPayload = ({
  flow,
  variant,
  locationKind,
  defaultEnabled,
}) => ({
  name: TRACKING_EVENT_NAMES.CTA_SHOWN,
  properties: {
    cta_key: NOTETAKER_ET_TOGGLE_CTA_KEY,
    cta_text: NOTETAKER_ET_TOGGLE_CTA_TEXT,
    cta_details: JSON.stringify({
      flow: getFlow(flow),
      variant,
      location_kind: locationKind,
      default_state: defaultEnabled ? 'on' : 'off',
    }),
  },
})

export const buildNotetakerEtToggleSavedTrackingPayload = ({
  eventTypeId,
  flow,
  isEnabled,
}) => {
  if (eventTypeId == null || typeof isEnabled !== 'boolean') return null

  return {
    name: TRACKING_EVENT_NAMES.SETTING_UPDATED,
    properties: {
      setting_name: NOTETAKER_ET_TOGGLE_SETTING_NAME,
      edit_type: [isEnabled ? 'enable' : 'disable'],
      location: `event_type_editor_${getFlow(flow)}`,
      event_type_id: [eventTypeId],
    },
  }
}
